import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { fetchSurgicalHistory } from "../redux/thunks/surgicalHistoryThunks";
import { fetchBmiHistoryByUserId } from "../redux/thunks/bmiHistoryThunks";
import {
  fetchMedicalHistory,
  fetchMedicalInfoByUserId,
} from "../redux/thunks/medicalThunks";
import { fetchPersonalHistoryByUserId } from "../redux/thunks/personalHistoryThunks";
import { fetchVaccinations } from "../redux/thunks/vaccinationThunks";
import { fetchVitalSignals } from "../redux/thunks/vitalThunks";

import { fetchPatientPrescriptions } from "../../prescriptions/redux/thunks/prescriptionThunks";

export default function useDoctorPatientData(patientId, doctorId, enabled = true) {
  const dispatch = useDispatch();

  const refresh = useCallback(() => {
    if (!enabled || !patientId || !doctorId) return Promise.resolve([]);

    return Promise.all([
      dispatch(fetchMedicalInfoByUserId(patientId)),
      dispatch(fetchMedicalHistory(patientId)),
      dispatch(fetchPersonalHistoryByUserId(patientId)),
      dispatch(fetchVaccinations(patientId)),
      dispatch(fetchVitalSignals({ userId: patientId })),
      dispatch(fetchSurgicalHistory(patientId)),
      dispatch(fetchBmiHistoryByUserId(patientId)),
      dispatch(fetchPatientPrescriptions({ doctorId, patientId })),
    ]);
  }, [dispatch, doctorId, enabled, patientId]);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  return { refresh };
}
